import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-vs-table',
  templateUrl: './vs-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./vs-table.component.css']
})
export class VsTableComponent implements OnInit {
  @Input() data;
  headers= [];
  constructor() {
  }

  ngOnInit() {
    this.headers = this.getHeaders(this.data);
     }

  getHeaders(data) {
    return Object.keys(data[0]);
  }
}



